import React from "react";
import { Check, Copy } from "lucide-react";

function CodeBlock({ code, lang }) {
  const [copied, setCopied] = React.useState(false);
  const copy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className="my-3 rounded-xl overflow-hidden border border-[#2A2A28] bg-[#1B1B1A]" data-testid="code-block">
      <div className="flex items-center justify-between px-4 py-2 bg-[#232321]">
        <span className="text-xs font-mono text-[#A7A79C]">{lang || "code"}</span>
        <button onClick={copy} className="flex items-center gap-1.5 text-xs text-[#A7A79C] hover:text-white" style={{ transition: "color 0.2s ease" }} data-testid="copy-code-button">
          {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <pre className="p-4 overflow-x-auto omni-scroll text-sm leading-relaxed"><code className="font-mono text-[#E8E8E2]">{code}</code></pre>
    </div>
  );
}

// Very small inline formatter: **bold** and `code`
function renderInline(text, keyPrefix) {
  const tokens = text.split(/(\*\*[^*]+\*\*|`[^`]+`)/g);
  return tokens.map((tok, i) => {
    if (tok.startsWith("**") && tok.endsWith("**")) {
      return <strong key={`${keyPrefix}-${i}`} className="font-semibold text-[#171716]">{tok.slice(2, -2)}</strong>;
    }
    if (tok.startsWith("`") && tok.endsWith("`")) {
      return <code key={`${keyPrefix}-${i}`} className="font-mono text-[13px] px-1.5 py-0.5 rounded bg-[#EFEFEA] text-[#2D6A4F]">{tok.slice(1, -1)}</code>;
    }
    return <span key={`${keyPrefix}-${i}`}>{tok}</span>;
  });
}

export default function MessageContent({ content }) {
  if (!content) return null;
  const parts = content.split(/```/);
  return (
    <div className="text-[15px] leading-relaxed text-[#26261F] break-words">
      {parts.map((part, idx) => {
        if (idx % 2 === 1) {
          const nl = part.indexOf("\n");
          const lang = nl > -1 ? part.slice(0, nl).trim() : "";
          const code = nl > -1 ? part.slice(nl + 1) : part;
          return <CodeBlock key={idx} code={code.replace(/\n$/, "")} lang={lang} />;
        }
        return (
          <div key={idx} className="whitespace-pre-wrap">
            {part.split("\n").map((line, li) => (
              <p key={li} className={line.trim() === "" ? "h-3" : "mb-1"}>{renderInline(line, `${idx}-${li}`)}</p>
            ))}
          </div>
        );
      })}
    </div>
  );
}
